import { Component, Input } from "@angular/core";

@Component({
  selector: "snoots-page-detail-header-icon",
  template: "",
  standalone: false
})
export class PageDetailHeaderIconComponent {
  @Input() icon: string | undefined;
  @Input() title: string | undefined;
}
